.skeleton {
  display: block;
  inline-size: 100%;
  block-size: 1em;
  border-radius: var(--radius-sm);
  background: var(--color-surface-active);
  animation: pulse var(--duration-pulse) ease-in-out infinite;
}

.skeleton[data-shape="title"] {
  block-size: var(--text-2xl);
}

.skeleton[data-shape="control"] {
  block-size: var(--control-md);
  border-radius: var(--radius-md);
}

.skeleton[data-shape="block"] {
  block-size: calc(var(--space-12) * 3);
  border-radius: var(--radius-lg);
}

.skeleton[data-width="3/4"] {
  inline-size: 75%;
}

.skeleton[data-width="1/2"] {
  inline-size: 50%;
}

.skeleton[data-width="1/4"] {
  inline-size: 25%;
}

.skeleton[data-width="custom"] {
  inline-size: min(100%, var(--skeleton-width, 100%));
}

.lines {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}
